import React, { ReactElement } from 'react';
import classNames from 'classnames';
// TODO: change to success animation
import errorAnimationData from 'app/assets/animations/Error.json';
import { useAppDispatch, useAppSelector, useModal } from 'app/hooks';
import { closeSuccessModal } from 'app/services/redux/slices';
import { ANIMATION_TYPE, Lottie, Modal } from '../index';
import { DEVICE_TYPE } from 'app/types';

import styles from './SuccessModal.module.scss';

interface Props {
  visible: boolean;
  header?: string;
  children?: ReactElement | ReactElement[];
  onClose?: () => void;
  modalClassName?: string;
  modalBodyClassName?: string;
}

function SuccessModal({
  visible,
  header,
  children,
  onClose,
  modalClassName,
  modalBodyClassName,
}: Props): ReactElement {
  const dispatch = useAppDispatch();

  return (
    <Modal
      wrapClassName={modalClassName}
      footer={null}
      centered
      visible={visible}
      onCancel={onClose}
    >
      <div className={classNames(styles.successModalBody, modalBodyClassName)}>
        <Lottie
          outerStyle={{
            width: DEVICE_TYPE.BIG_MOBILE ? '70%' : '50%',
            maxWidth: '300px',
            margin: '0 auto',
          }}
          animationType={ANIMATION_TYPE.infinity}
          src={errorAnimationData}
        />
        <h4>{header}</h4>
        {children}
      </div>
    </Modal>
  );
}

export default SuccessModal;
